<app-custom-dropdown
        [data]="dropdownList"
        [(ngModel)]="selectedItems"
        [settings]="dropdownSettings"
        [content]="content"
        (onSelect)="onItemSelect($event)"
        (onDeSelect)="OnItemDeSelect($event)"
        (onSelectAll)="onSelectAll($event)"
        [checkForAdvertisers]="checkForAdvertisers"
        (onDeSelectAll)="onDeSelectAll($event)">
</app-custom-dropdown>
